/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */
import * as AwsAmplifyConfig from '@root-enums/services';

export const awsConfig = {
    API: {
      endpoints: [
        {
          endpoint: AwsAmplifyConfig.AwsapiGateway.URL,
          name: "notes",
          region: AwsAmplifyConfig.AwsapiGateway.REGION
        },
      ]
    },
    Auth: {
      identityPoolId: AwsAmplifyConfig.Awsapicognito.IDENTITY_POOL_ID,
      mandatorySignIn: true,
      region: AwsAmplifyConfig.Awsapicognito.REGION,
      userPoolId: AwsAmplifyConfig.Awsapicognito.USER_POOL_ID,
      userPoolWebClientId: AwsAmplifyConfig.Awsapicognito.APP_CLIENT_ID
    },
    Storage: {
      bucket: AwsAmplifyConfig.AwsS3.BUCKET,
      identityPoolId: AwsAmplifyConfig.Awsapicognito.IDENTITY_POOL_ID,
      region: AwsAmplifyConfig.AwsS3.REGION,
    },
   
  }


// WEBPACK FOOTER //
// ./src/root/services/aws/index.ts